/* 確認用モーダル */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
var ModalConfirm = function (_a) {
    var show = _a.show, title = _a.title, body = _a.body, clickCallBackConfirm = _a.clickCallBackConfirm;
    return (React.createElement(Modal, { size: "lg", centered: true, show: show, onHide: function () { } },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, { className: "dialog-title" }, title)),
        React.createElement(Modal.Body, { className: "dialog-body" }, body),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { variant: "main-color", onClick: clickCallBackConfirm }, "\u78BA\u8A8D"))));
};
export default ModalConfirm;
